import { colors } from '@kmns-internal/furikake/tokens'
import { Delete, MoreHoriz } from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material'
import type { MultipleChoiceSet } from '@ulysses-inc/harami_api_client'
import type { FC, MouseEvent } from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'

interface IProps {
  multipleChoiceSet: MultipleChoiceSet
  deleteMultipleChoiceSet: (multipleChoiceSetId: string) => void
}

const MultipleChoiceSetListRow: FC<IProps> = ({
  multipleChoiceSet: { uuid, name },
  deleteMultipleChoiceSet,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)

  const handleMenuClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    event.preventDefault()
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(null)
  }

  const handleClickDelete = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setOpenDeleteDialog(true)
  }

  const handleCloseDeleteDialog = (event: MouseEvent<HTMLElement>) => {
    setOpenDeleteDialog(false)
    handleMenuClose(event)
  }

  const handleDelete = (event: MouseEvent<HTMLElement>) => {
    deleteMultipleChoiceSet(uuid ?? '')
    setOpenDeleteDialog(false)
    handleMenuClose(event)
  }

  return (
    <>
      <TableRow
        hover
        component={Link}
        to={`/multipleChoiceSets/${uuid ?? ''}`}
        sx={{ textDecoration: 'none' }}
      >
        <TableCell size="small">
          <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
            {name}
          </Typography>
        </TableCell>
        <TableCell size="small" sx={{ minWidth: '96px' }} align="right">
          <IconButton
            onClick={handleMenuClick}
            aria-label={`${name}のメニューを開く`}
          >
            <MoreHoriz />
          </IconButton>
        </TableCell>
      </TableRow>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={handleClickDelete}
          sx={{
            color: colors.error.main,
            gap: 1,
            '&:hover': {
              backgroundColor: colors.error.hover,
              color: colors.error.main,
            },
          }}
        >
          <Delete fontSize="small" />
          削除
        </MenuItem>
      </Menu>
      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogTitle>{`「${name}」を削除しますがよろしいですか？`}</DialogTitle>
        <DialogActions>
          <Button
            color="secondary"
            variant="contained"
            onClick={handleCloseDeleteDialog}
          >
            キャンセル
          </Button>
          <Button color="error" variant="contained" onClick={handleDelete}>
            削除
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default MultipleChoiceSetListRow
